/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const AutogiroApprovalType = {
    AUTOGIRO: 'AUTOGIRO',
    SEPA_DIRECT_DEBIT: 'SEPA_DIRECT_DEBIT',
    OVERFORSELSSERVICE: 'OVERFORSELSSERVICE',
    DIRECT_DEBIT_NORWAY: 'DIRECT_DEBIT_NORWAY'
} as const;

export type AutogiroApprovalType = typeof AutogiroApprovalType[keyof typeof AutogiroApprovalType];



